import {pagination} from 'src/app/utils/pagination';
import {Nullable, vconsultation} from '..';
import {Search} from '../Search';

export interface ConsultationSearch {
    pbkStrFr: string;
    shopInstCd: string;
    bizKindStrEn: string;
    publicDt: Date;
    publicYn: string;
    shopModSeq: string;
    pbkStrEn: string;
    bizKindStrFr: string;
    cdNmAr: string;
    shopNmFr: string;
    bizKindStrAr: string;
    pbkStrAr: string;
    shopNmAr: string;
    spShopMasterId: number;
    instNm: string;
    bizKindStrId: number;
    spRecvEndDtStr: string;
    shopNmEn: string;
    pbkStrId: number;
    publicDtStr: string;
    cdNmFr: string;
    shopNo: string;
    cdNmEn: string;
    spRecvEndDt: Date;
}

export interface SearchOptions {
    pbkStrFr: Nullable<string>;
    shopInstCd: Nullable<string>;
    bizKindStrEn: Nullable<string>;
    publicDt: Nullable<string>;
    publicYn: Nullable<string>;
    shopModSeq: Nullable<string>;
    pbkStrEn: Nullable<string>;
    bizKindStrFr: Nullable<string>;
    cdNmAr: Nullable<string>;
    shopNmFr: Nullable<string>;
    bizKindStrAr: Nullable<string>;
    pbkStrAr: Nullable<string>;
    shopNmAr: Nullable<string>;
    spShopMasterId: Nullable<string>;
    instNm: Nullable<string>;
    bizKindStrId: number;
    spRecvEndDtStr: Nullable<string>;
    shopNmEn: Nullable<string>;
    pbkStrId: Nullable<string>;
    publicDtStr: Nullable<string>;
    cdNmFr: Nullable<string>;
    shopNo: Nullable<string>;
    cdNmEn: Nullable<string>;
    spRecvEndDt: Nullable<string>;
    publicDt_end: Nullable<string>;
    epFr: Nullable<string>;
    epAr: Nullable<string>;
    epEn: Nullable<string>;
    spRecvStartDt: Nullable<string>;
    spOpenDt: Nullable<string>;
    shopExpiredDays: Nullable<string>;
    regId: Nullable<string>;
    regNm: Nullable<string>;
    examId: Nullable<string>;
    examNm: Nullable<string>;
    bcId: Nullable<string>;
    bcNm: Nullable<string>;
    refNo: Nullable<string>;
    masterCdBc: Nullable<string>;
    masterCdExam: Nullable<string>;
    bizKindCd: Nullable<string>;
    spRecvEndDtStr_end: Nullable<string>;
}

export type SearchModel = Search<SearchOptions>;

export function createSearchOptions(options?: Partial<SearchOptions>) {
    const defaultOptions: SearchModel = {
        pbkStrFr: null,
        shopInstCd: null,
        bizKindStrEn: null,
        publicDt: null,
        publicYn: null,
        shopModSeq: null,
        pbkStrEn: null,
        bizKindStrFr: null,
        cdNmAr: null,
        shopNmFr: null,
        bizKindStrAr: null,
        pbkStrAr: null,
        shopNmAr: null,
        spShopMasterId: null,
        instNm: null,
        bizKindStrId: null,
        spRecvEndDtStr: null,
        shopNmEn: null,
        pbkStrId: null,
        publicDtStr: null,
        cdNmFr: null,
        shopNo: null,
        cdNmEn: null,
        spRecvEndDt: null,
        publicDt_end: null,
        epFr: null,
        epAr: null,
        epEn: null,
        spRecvStartDt: null,
        spOpenDt: null,
        shopExpiredDays: null,
        regId: null,
        regNm: null,
        examId: null,
        examNm: null,
        bcId: null,
        bcNm: null,
        refNo: null,
        masterCdBc: null,
        masterCdExam: null,
        bizKindCd: null,
        spRecvEndDtStr_end: null,
        pagination: {
            limit: 12 || pagination.itemsPerPage,
            offSet: 0,
        },
        sort: {
            nomCol: null,
            direction: null,
        },
    };

    return Object.assign({}, defaultOptions, options);
}

export function getLabels(): Record<keyof vconsultation, string> {
    return {
        spRecvEndDt: 'Dernier délai de réception des offres',
        pbkStrFr: 'Type de commande',
        shopInstCd: 'string',
        bizKindStrEn: 'string',
        publicDt: 'Date de publication',
        publicYn: 'string',
        shopModSeq: 'string',
        pbkStrEn: 'string',
        bizKindStrFr: 'Classification détaillée',
        cdNmAr: 'string',
        cdNmEn: 'string',
        shopNmFr: 'Nom de la consultation',
        bizKindStrAr: 'string',
        pbkStrAr: 'string',
        shopNmAr: 'string',
        spShopMasterId: 'string',
        instNm: 'Acheteur publique',
        bizKindStrId: 'string',
        spRecvEndDtStr: 'Dernier délai de réception des offresi',
        shopNmEn: 'string',
        pbkStrId: 'string',
        publicDtStr: 'string',
        cdNmFr: 'string',
        shopNo: 'N° de la consultation',
        epFr: 'string',
        epAr: 'string',
        epEn: 'string',
        spRecvStartDt: 'string',
        spOpenDt: 'string',
        shopExpiredDays: 'string',
        regId: 'string',
        regNm: 'string',
        examId: 'string',
        examNm: 'string',
        bcId: 'string',
        bcNm: 'string',
        instNmAr: 'Acheteur Public',
        instNmEn: 'Acheteur Public',
        affectationcheck: 'Y',
        internationalShopYn: '',
        refNo: '',
        masterCdBc: '',
        masterCdExam: '',
        bizKindCd: '',
        spRecvEndDtStr_end: '',
        emailInst: ''

    };
}
